module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/415.4cbe1802.png";